<template>
	<ui-modal-template>
		<template v-slot:title>
			<span>Kontrakt bearbeiten</span>
		</template>
		<template v-slot:content>
			<form class="h-full flex flex-col">
				<div class="px-6 sm:px-12 py-6">
					<ui-input-group
						class="basis-full sm:basis-[30.75%]"
						v-model="form.qty__mt"
						field="qty__mt"
						label="Menge"
						:form="form"
						:required="true"
						suffix="t"
					/>
				</div>

				<div class="bg-gray-100 p-6 sm:px-12">
					<div class="flex justify-end">
						<ui-button
							:disabled="form.processing"
							v-on:click="submitForm()"
							label="Speichern"
						/>
					</div>
				</div>
			</form>
		</template>
	</ui-modal-template>
</template>

<script>
import axios from "axios";
import Vue from "vue";
export default {
	props: {
		id: {
			required: true,
			type: Number,
		},
		qty__mt: {
			required: true,
			type: [Number, String],
		},
	},
	data() {
		return {
			form: Vue.observable(
				this.$inertia.form({
					qty__mt: parseFloat(this.qty__mt),
				})
			),
		};
	},
	methods: {
		async submitForm() {
			this.form.processing = true;
			const route = this.$route("admin.contracts_update", { id: this.id });
			axios
				.patch(route, this.form)
				.then(this.onSuccess)
				.catch(this.onError)
				.finally(() => {
					this.form.processing = false;
				});
		},
		onSuccess() {
			this.$bus.$emit("modal:close");
			window.location.reload();
		},
		onError(error) {
			if (error.response?.status === 422) {
				this.$bus.$emit("form:invalid", error.response.data.errors);
			} else {
				this.$bus.$emit("modal:error", error);
			}
		},
	},
};
</script>
